import { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import qs from 'qs';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from 'components/CncUI/Typography';
import Loader from 'components/Loader';
import useMutation from 'hooks/useMutation';
import cncLogo from 'images/MyCast&CrewLogo.svg';

const useStyles = makeStyles(({ palette, breakpoints, spacing }) => ({
  '@global': {
    '.CnC-Menu-Bar': {
      display: 'none',
    },
  },
  root: {
    width: '100%',
    backgroundColor: palette.cncUI.default.background,
    maxHeight: '100%',
    height: '100%',
    overflowY: 'auto',
    [breakpoints.down('md')]: {
      overflowY: 'auto',
    },
  },
  content: {
    padding: `0 ${spacing(3)}px ${spacing(3)}px`,
    [breakpoints.down('sm')]: {
      padding: `0 ${spacing(2)}px ${spacing(2)}px`,
    },
  },
  header: {
    backgroundColor: palette.cncUI.default.primary,
    boxShadow: 'none',
  },
  toolbar: {
    [breakpoints.up('md')]: {
      paddingLeft: 50,
    },
  },
  logo: {
    flexGrow: 1,
    textAlign: 'center',
    [breakpoints.up('md')]: {
      textAlign: 'left',
    },
    '& img': {
      width: 154,
      marginTop: 2,
    },
  },
}));

const ConfirmEmail = ({ location: { search } }) => {
  const classes = useStyles();
  const { t: token } = qs.parse(search.slice(1));
  const [loading, setLoading] = useState(true);

  const confirmEmail = useMutation('confirmEmailProfileUpdate', {
    scopes: null,
    request: token => ({ token }),
    response: res => res.data.confirmEmailProfileUpdate,
  });

  useEffect(() => {
    confirmEmail(token)
      .then(() => setLoading(false))
      .catch(err => {
        setLoading(false);
        console.error(err);
      });
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.header}>
        <Toolbar className={classes.toolbar}>
          <Typography variant="h6" color="inherit" className={classes.logo}>
            <img alt="logo" align="center" src={cncLogo} />
          </Typography>
        </Toolbar>
      </AppBar>
      <div className={classes.content}>
        <Grid container spacing={1} style={{ marginTop: 40 }}>
          <Grid item xs={12}>
            <Typography variant="h4">Change Authorized</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" noMargin>
              Your identity has been confirmed. You can now close this window on
              your desktop, or close the tab on your mobile device.
            </Typography>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default ConfirmEmail;
